function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const getApiUrl = ()=>{
    const MONDAY_API_URL = process.env.MONDAY_API_URL;
    const isDevelopment = process.env.ENV == "DEV";
    if (isDevelopment) {
        return MONDAY_API_URL;
    }
    const httpsUrl = MONDAY_API_URL.replace(/^http:/, "https:");
    return httpsUrl;
};
export const graphQLFetcher = (graphQLParams, { onAuthorized, tokenString, version, headers })=>{
    const finalHeaders = _object_spread_props(_object_spread({
        "Content-Type": "application/json"
    }, version ? {
        "API-Version": version
    } : {}, headers || {}), {
        Authorization: tokenString
    });
    return fetch(getApiUrl(), {
        method: "post",
        headers: finalHeaders,
        body: JSON.stringify(graphQLParams)
    }).then((response)=>{
        if (response.status !== 401) {
            onAuthorized();
        }
        return response.json();
    });
};
